import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';

import { apiBaseUrl } from '../constants';
import { useLogin } from '../providers/Login';
import Swal from 'sweetalert2'

const Login = () => {

    const [form] = Form.useForm()
    const { doLogin } = useLogin()

    const onFinish = async (values) => {
        try {
            const response = await fetch(`${apiBaseUrl}/action/Usuario/logar`, { method: 'POST', body: JSON.stringify(values) })
            const data = await response.json()

            if (!response.ok) {
                throw new Error(data.message || 'Erro ao fazer login')
            }

            doLogin({ token: data.accessToken, usuario: values.usuario })

        } catch (error) {
            Swal.fire({
                title: 'Ocorreu um erro',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'OK'
            })
        }
    }

    return (
        <Form style={{ margin: '130px auto 0px auto' }} form={form} name="normal_login" className="login-form" initialValues={{ remember: true }} onFinish={onFinish}>
            <Form.Item name="usuario" rules={[{ required: true, message: 'Insira seu usuário!' }]} >
                <Input autoFocus prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Usuário" />
            </Form.Item>
            <Form.Item name="senha" rules={[{ required: true, message: 'Insira sua senha!' }]} >
                <Input prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder="Senha" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" className="login-form-button">
                    Entrar
                </Button>
            </Form.Item>
        </Form>
    )
}

export default Login